import { useQuery } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { IPromptJobOutput } from "../models/entities/prompt-job-output.model";

export const usePromptJobOutputs = ({ participantId }: { participantId: number }) => {
	const queryKey = ["prompt-job-outputs", { participantId }];

	return useQuery({
		queryKey: queryKey,

		queryFn: async (): Promise<IPromptJobOutput[]> =>
			EndpointsService.dataRetriever.getPromptJobOutputs({ participantId }),

		enabled: !!participantId && participantId > 0,
	});
};
